"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = exports.TitleWithDesktopMargin = exports.TextWrapper = exports.Root = exports.OneMediaRoot = exports.ImageBox = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _shared = require("../shared");
var _constants = require("./constants");
const Wrapper = exports.Wrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignSelf: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4, 0),
        alignItems: 'center',
        width: '100%',
        maxWidth: _constants.IMAGE_DESKTOP_WIDTH,
        [theme.breakpoints.up('sm')]: {
            alignSelf: 'auto'
        }
    };
});
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(6),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            maxWidth: 985,
            flexDirection: 'row',
            gap: 0,
            justifyContent: 'center',
            margin: '0 auto'
        }
    };
});
const OneMediaRoot = exports.OneMediaRoot = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: theme.spacing(6),
        [theme.breakpoints.up('sm')]: {
            alignItems: 'normal',
            flexDirection: 'row'
        },
        [theme.breakpoints.up('md')]: {
            gap: 0
        }
    };
});
const TextWrapper = exports.TextWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
        [".".concat(_presentationComponents.textWithHtmlClasses.text)]: {
            fontSize: '1.4rem',
            alignItems: 'flex-start',
            padding: theme.spacing(0, 3)
        },
        marginLeft: 0,
        overflow: 'hidden',
        letterSpacing: 0,
        [theme.breakpoints.up('md')]: {
            width: 550,
            marginLeft: theme.spacing(16),
            gap: theme.spacing(3),
            [".".concat(_presentationComponents.textWithHtmlClasses.text)]: {
                padding: 0
            }
        }
    };
});
const TitleWithDesktopMargin = exports.TitleWithDesktopMargin = (0, _mui.styled)(_shared.Title)((param)=>{
    let { theme } = param;
    return {
        [theme.breakpoints.up('md')]: {
            margin: theme.spacing(0, 3)
        }
    };
});
const ImageBox = exports.ImageBox = (0, _mui.styled)(_shared.ImageBox)({
    alignSelf: 'center'
});
